/**
 * Section services component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Button from '../button/button';
import Cards from '../cards/cards';
import Image from '../image/image';

export default class SectionServices extends PureComponent {

	render() {
		
		const { data, items, template } = this.props;

		if (data.background && data.background.url) {

			return (

				<div className="section section-background text-center">
					<div className="section-content container">

						{ !! data.title && <h2>{data.title}</h2> }
						{ !! data.lead && <p className="lead">{data.lead}</p> }
						{ !! data.title && <hr className="sm" /> }

	                    <Cards items={items} template={template} />

	                    { !! data.link && <Button url={data.link} label={data.link_label} color="primary" size="wide" /> }

					</div>
					<div className="section-graphic">

						<div className="section-cover"><Image data={data.background}/></div>

					</div>
				</div>
			)
		}
		else {

			return (

				<div className="section text-center">
					<div className="section-content container pb-9">

						<h2>{data.title}</h2>
	                    <p className="lead">{data.lead}</p>
	                    <hr className="sm" />

	                    <Cards items={items} template={template} />

	                    { !! data.link && <Button url={data.link} label={data.link_label} color="primary" size="wide" /> }
	                    
					</div>
				</div>
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-services.js